module.exports = __webpack_public_path__ + "img/arrowIcon.011cd8f9.svg";